export const Jobs_within_miles_of_your_address = 1;
export const Jobs_matching_preferred_test_centres = 2;
export const Jobs_match_preferred_test_centers_and_miles = 3;
